module.exports = __webpack_public_path__ + "vpmobile/static/media/style.0c7d4df6.less";